module.exports = {
        srcSet: __webpack_public_path__ + "static/media/movingBox-498.101a4c51.webp"+" 498w",
        images: [{path: __webpack_public_path__ + "static/media/movingBox-498.101a4c51.webp",width: 498,height: 498}],
        src: __webpack_public_path__ + "static/media/movingBox-498.101a4c51.webp",
        toString: function(){return __webpack_public_path__ + "static/media/movingBox-498.101a4c51.webp"},
        
        width: 498,
        height: 498
      }